import { useContext } from 'react';
import * as React from 'react';
import { PostPurchaseContext } from '@/features/editor/widgets/post-purchase/context';
import { RadioButtons } from '@/features/editor/widgets/custom-widget/inputs/shared/radio-buttons';
import { DropdownInputOption } from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';

import { StylingComponentsGroup } from '@/features/editor/widgets/post-purchase/styling/group';

export function PostPurchasePreselectVariant() {
  const {
    props: {
      settings: { preselectVariant },
    },
    setProps,
  } = useContext(PostPurchaseContext);

  const options: DropdownInputOption[] = [
    { label: `No`, value: `false` },
    { label: `Yes`, value: `true` },
  ];

  const onChange = (val: string) => {
    setProps((draft) => {
      draft.settings.preselectVariant = val === `true`;
    });
  };

  return (
    <StylingComponentsGroup title="Preselect Variant">
      <RadioButtons
        title="Preselect Variant on default"
        smallTitle
        options={options}
        defaultValue={preselectVariant === false ? `false` : `true`}
        onChange={onChange}
      />
    </StylingComponentsGroup>
  );
}
